import { PageHero } from "@/components/site/PageHero";
import { FadeUp, LineReveal } from "@/components/site/Reveal";
import { CtaBand } from "@/components/site/CtaBand";
import { QUESTIONS } from "@/lib/content2";

const GROUPS = [
  { id: "salesperson", eyebrow: "Questions 01–06", title: ["Ask the", "salesperson."], note: "Seriously — if a dodgy salesman hears even one of these, they'll probably start running for the hills." },
  { id: "yourself", eyebrow: "Questions 07–13", title: ["Ask", "yourself."], note: "Do your own homework on the company, the panels and the inverter before you sign anything." },
];

const Item = ({ q, n }) => (
  <FadeUp data-testid={`guide-question-${n}`} className="group grid grid-cols-[auto_1fr] gap-5 sm:gap-8 py-8 border-t border-white/10">
    <span className="font-display font-black text-5xl sm:text-6xl text-outline group-hover:text-[var(--sun)] transition-colors duration-300 leading-none w-16 sm:w-20">{String(n).padStart(2, "0")}</span>
    <div>
      <h3 className="font-display font-bold uppercase text-2xl sm:text-3xl leading-tight">{q.q}</h3>
      <p className="mt-3 text-slate-300 leading-relaxed max-w-2xl">{q.a}</p>
    </div>
  </FadeUp>
);

export default function Guide() {
  let n = 0;
  return (
    <div data-testid="guide-page">
      <PageHero testId="guide-hero" eyebrow="Buyer's guide" lines={["13 questions", "to weed out", "the shonks."]} intro="“I've been made a fantastic offer… it's heaps cheaper than all the others. Is it too good to be true?” If it sounds too good to be true, it probably is. Most installers are good people — but some still bang cheap solar junk on your roof using underpaid subcontractors. Here's how to sort the wheat from the chaff." />
      {GROUPS.map((g, gi) => (
        <section key={g.id} className={gi ? "bg-[var(--navy)]" : "bg-[var(--ink)]"}>
          <div className="mx-auto max-w-[1440px] px-5 lg:px-10 py-20 lg:py-28 grid lg:grid-cols-12 gap-10">
            <div className="lg:col-span-4">
              <div className="lg:sticky lg:top-32">
                <p className="eyebrow">{g.eyebrow}</p>
                <LineReveal onView lines={g.title} className="mt-5 font-display font-black uppercase leading-[0.88] text-5xl sm:text-6xl" />
                <p className="mt-6 text-slate-300">{g.note}</p>
              </div>
            </div>
            <div className="lg:col-span-8">
              {QUESTIONS.filter((q) => q.group === g.id).map((q) => { n += 1; return <Item key={q.q} q={q} n={n} />; })}
            </div>
          </div>
        </section>
      ))}
      <CtaBand />
    </div>
  );
}
